import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import DebitnoteForm from "@components/forms/DebitNoteForm";
import DocumentReferencesOffCanvas from "@components/layout/Offcanvas/DocumentReferencesOffCanvas";
import { OpenDocumentReferencesPubSub } from "@utils/pubsubs/PubSub";
import { useAppSelector } from "@/store/hooks";

const DebitnoteAdd = () => {
  const documentReferences = useAppSelector((state) => state.eDocument.documentReferences)
  const params = useParams()
  const { invoiceId } = params;

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title="Agregar Nota de Debito"
      backUrl="/user/debitnotes"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "debitnoteAdd",
          type: "submit",
          color: "success"
        }
      ]}
      secondaryActions={[
        {
          actionTitle: `Referencias de Documento (${documentReferences.length})`,
          onClick: () => {
            OpenDocumentReferencesPubSub.publish({ openOffCanvas: true, documentKind: "Debitnote" })
          }
        }
      ]}
    >
      <DebitnoteForm
        invoiceId={`${invoiceId}`}
        saveRedirectUrl="/user/debitnotes"
        formId="debitnoteAdd" >
      </DebitnoteForm>

      <DocumentReferencesOffCanvas />

    </PageContainer>
  );
}

export default DebitnoteAdd;
